import React from 'react';
import './About.css';

const AboutVision = () => {
  return (
    <section id="about" className="about section">
      <div className="about-content">
        <div className="about-image">
          <img 
            src="/Our Vision.jpeg" 
            alt="A-frame cabin in nature" 
          />
        </div>
        <div className="about-text">
          <h2 className="about-title">Our Vision</h2>
          <div className="about-description">
            <p>
              "Amoda" means joy and "Sari" means essence — together, the essence of joy.<br />
              Our vision is to craft sanctuaries where thoughtful design meets Himalayan nature:<br />
              villas, glamping domes, and cozy cabins woven gently into the landscape.<br />
              <br />
              We favor slow living over speed, connection over noise, and materials that age well.<br />
              Shared spaces — clubhouse, co‑working corners, trails, and quiet decks — nurture
              community while keeping nature first. Every detail is designed to feel calm, kind,
              and deeply livable.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutVision;


